import { useAuth } from '@praxis/component-auth'
import {
  useIsFetching,
  useIsMutating,
  useQueryClient,
} from '@tanstack/react-query'
import {
  Anchor,
  Button,
  GridContainer,
  GridItem,
  Modal,
} from '@enterprise-ui/canvas-ui-react'
import { useCallback, useEffect, useState } from 'react'
import { trackLogOut } from '../../common/fireflyEvents'
import { isPOLDomain, removeLocalStorageItems } from '../../common/helper'
import { SIGN_OUT } from '../../constants'
import { StyledForbiddenModal } from './styles'
import {
  POL_DEV_SUPPORT_LINK,
  POL_PROD_SUPPORT_LINK,
} from '../../config/appConfig'
import apiConfig from '../../config/apiConfig'

const ForbiddenModal = () => {
  const queryClient = useQueryClient()
  const auth = useAuth()
  const isLoading = useIsMutating() + useIsFetching()
  const [supportURL, setSupportURL] = useState<string>()

  const signOut = useCallback(() => {
    trackLogOut()
    removeLocalStorageItems(['selected_vendor', 'external_vendor_detail'])
    auth.logout()
    queryClient.clear()
  }, [auth, queryClient])

  const getRmsSupportCenterURL = () => {
    if (isPOLDomain(window.location.origin)) {
      return apiConfig?.roundelHelpCenterPolURL
    } else {
      return apiConfig?.roundelHelpCenterEnterpriseURL
    }
  }

  useEffect(() => {
    if (apiConfig && Object.keys(apiConfig).length > 1) {
      setSupportURL(
        `${getRmsSupportCenterURL()}${apiConfig?.supportURLs?.RMS?.ticket}`,
      )
    }
  }, [apiConfig])

  return (
    <>
      {' '}
      {!isLoading && (
        <StyledForbiddenModal>
          <Modal headingText="Data not available" isVisible>
            <div className="hc-pa-normal hc-pa-lg  hc-fs-md">
              <div>
                You don't seem to have access to this account. If you believe
                this is an error, please submit a support ticket{' '}
                <Anchor href={supportURL} target="_blank">
                  here
                </Anchor>
                .
              </div>
              <br />
              <div>
                To learn more about running digital media campaigns with
                Roundel, reach out to your Roundel representative or learn more
                at{' '}
                <Anchor href="https://roundel.com/" target="_blank">
                  www.Roundel.com
                </Anchor>
              </div>

              <GridContainer direction="row-reverse" spacing="dense">
                <GridItem>
                  <Button
                    type="primary"
                    data-test="sign-out"
                    onClick={() => {
                      signOut()
                    }}
                  >
                    {SIGN_OUT}
                  </Button>
                </GridItem>
              </GridContainer>
            </div>
          </Modal>
        </StyledForbiddenModal>
      )}
    </>
  )
}

export default ForbiddenModal
